import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import React from 'react'
import { controlHasError } from '../../lib/errorHandler'
import ExpandablePanel from '../controls/ExpandablePanel'
import KasKrsV12 from '../KasKrsV12'

class IdentyfikacjaPodmiotuSkroconaV12 extends React.Component {
  render() {
    const { errors, data, onSetSectionData, onLoadGUS, onSetName } = this.props
    return (
      <ExpandablePanel title="IDENTYFIKACJA PODMIOTU">
        <form
          name="IdentyfikacjaPodmiotuSkroconaV12"
          autoComplete="off"
          className="identyfikacjaPodmiotu"
        >
          <KasKrsV12
            className="kasKrs"
            hasError={(name) => controlHasError(errors, name)}
            data={{
              NrNIP: data.NrNIP || '',
              NrKRS: data.NrKRS || '',
            }}
            onSetSectionData={(e) => {
              onSetSectionData(e.target.name, e.target.value)
            }}
            onLoadGUS={onLoadGUS}
          />
          <FormControl component="fieldset" className="nazwa">
            <TextField
              error={controlHasError(errors, 'NazwaFirmy')}
              name="NazwaFirmy"
              label="Nazwa pełna"
              title={data.NazwaFirmy}
              value={data.NazwaFirmy}
              onChange={(e) => {
                onSetSectionData(e.target.name, e.target.value)
                onSetName(e.target.value)
              }}
            />
          </FormControl>
        </form>
      </ExpandablePanel>
    )
  }
}

export default IdentyfikacjaPodmiotuSkroconaV12
